import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import API from "../../utils/api";

import {
  TOKEN_COOKIE,
  REFRESH_COOKIE
} from "../../utils/constant";

const initialState = {

  token:
    Cookies.get(TOKEN_COOKIE) || null,

  loading: false,

  error: null,
};

// ---------------------------------
// SIGN IN
// ---------------------------------

export const signIn =
  createAsyncThunk(

    "auth/signIn",

    async (
      signInForm,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.auth.signIn(
            signInForm
          );

        const _data =
          data.data;

        return {

          token:
            _data.token,

          refreshToken:
            _data.refreshToken
        };

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// SIGN UP
// ---------------------------------

export const signUp =
  createAsyncThunk(

    "auth/signUp",

    async (
      signUpForm,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.auth.signUp(
            signUpForm
          );

        const _data =
          data.data;

        return {

          token:
            _data.token,

          refreshToken:
            _data.refreshToken
        };

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// SLICE
// ---------------------------------

const authSlice = createSlice({

  name: "auth",

  initialState,

  reducers: {

    clearError: (state) => {

      state.error = null;
    },

    logout: (state) => {

      Cookies.remove(
        TOKEN_COOKIE
      );

      Cookies.remove(
        REFRESH_COOKIE
      );

      state.token = null;
    },
  },

  extraReducers: (builder) => {

    builder

      // ---------------------------------
      // SIGN IN
      // ---------------------------------

      .addCase(
        signIn.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        signIn.fulfilled,

        (state, action) => {

          state.token =
            action.payload.token;

          state.loading = false;

          // Save access token
          Cookies.set(

            TOKEN_COOKIE,

            action.payload.token,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );

          // Save refresh token
          Cookies.set(

            REFRESH_COOKIE,

            action.payload.refreshToken,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );
        }
      )

      .addCase(
        signIn.rejected,

        (state, action) => {

          state.error =
            action.payload?.response;

          state.loading = false;
        }
      )

      // ---------------------------------
      // SIGN UP
      // ---------------------------------

      .addCase(
        signUp.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        signUp.fulfilled,

        (state, action) => {

          state.token =
            action.payload.token;

          state.loading = false;

          // Save access token
          Cookies.set(

            TOKEN_COOKIE,

            action.payload.token,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );

          // Save refresh token
          Cookies.set(

            REFRESH_COOKIE,

            action.payload.refreshToken,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );
        }
      )

      .addCase(
        signUp.rejected,

        (state, action) => {

          state.error =
            action.payload?.response
              ?.data?.msg;

          state.loading = false;
        }
      );
  },
});

export const selectToken =
  (state) => state.auth.token;

export const selectError =
  (state) => state.auth.error;

export const selectLoading =
  (state) => state.auth.loading;

export const {
  logout,
  clearError
} = authSlice.actions;

export default authSlice.reducer;
